/**
 * Supabase Client Configuration
 *
 * White-labeled: No Supabase branding is exposed to end users.
 * The Supabase URL is only used internally for API calls.
 */
import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.warn(
    'Database credentials not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your environment.'
  );
}

export const supabase: SupabaseClient<Database> = createClient<Database>(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key-not-configured',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storageKey: 'userlife-auth-token',
    },
    global: {
      headers: {
        'x-application-name': 'userlife-jml',
      },
    },
  }
);

export default supabase;

// Re-export common types for ergonomic imports.
export type { Database } from './database.types';
